export const NavigationStackEvents = {
    Push: 'Push',
    Pop: 'Pop',
    Update: 'Update',
    Navigate: 'Navigate',
    CheckPage: 'CheckPage',
    CheckNavigatability: 'CheckNavigatability',
    Checked: 'Checked'
};